import { render, staticRenderFns } from "./PicturePlaceholder.vue?vue&type=template&id=7451e0f2"
import script from "./PicturePlaceholder.vue?vue&type=script&lang=js"
export * from "./PicturePlaceholder.vue?vue&type=script&lang=js"
import style0 from "./PicturePlaceholder.vue?vue&type=style&index=0&id=7451e0f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports